import { Box, Divider, Heading, Text } from '@wix/design-system';
import React, { FC, PropsWithChildren } from 'react';
import styles from './Webpage.scss';
import { WebpageHeader } from './WebpageHeader';

type Props = PropsWithChildren<{
  menuItems: string[];
  selectedMenuItemIndex: number;
  headerTitle?: string;
}>;

export const Webpage: FC<Props> = ({ menuItems, selectedMenuItemIndex, headerTitle, children }) => {
  return (
    <div className={styles.webpage}>
      <WebpageHeader menuItems={menuItems} selectedMenuItemIndex={selectedMenuItemIndex} title={headerTitle} />
      <Divider />
      <div className={styles.webpageContent}>{children}</div>
    </div>
  );
};
